import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkBox", "subscriptionCancellationRequestModal", "reasonSelect", "submitButton"]

  connect() {
    $(this.checkBoxTarget).change(this.submitForm.bind(this))
  }

  submitForm(ev) {
    if (!this.autorenewIsOn) {
      $(this.subscriptionCancellationRequestModalTarget).modal("show")
      $(this.subscriptionCancellationRequestModalTarget).on("hidden.bs.modal", this.resetToggle.bind(this))
    } else {
      ev.target.form.requestSubmit()
    }
  }

  handleSelectedReason() {
    this.submitButtonTarget.disabled = (this.reasonSelectTarget.value === "")
  }

  handleSuccess(ev) {
    $(this.subscriptionCancellationRequestModalTarget).modal("hide")
    this.emulateFlash(ev, "success")
  }

  handleError(ev) {
    this.emulateFlash(ev, "danger")
    this.resetToggle()
  }

  get autorenewIsOn() {
    return this.checkBoxTarget.checked
  }

  resetToggle() {
    const innerElement = $(this.checkBoxTarget).data("bs.toggle")
    if (this.autorenewIsOn) {
      innerElement.off(true)
    } else {
      innerElement.on(true)
    }
  }

  emulateFlash(e, status) {
    const flashElement = document.querySelector("#alert-box > .alert")
    const closeButton = flashElement.children[0]
    flashElement.classList.remove("hidden", "alert-danger", "alert-success")
    flashElement.classList.add(`alert-${status}`)
    flashElement.innerHTML = ""
    flashElement.appendChild(closeButton)
    flashElement.append(e.detail[0].message)
  }

  hideFlash() {
    const flashElement = document.querySelector("#alert-box > .alert")
    flashElement.classList.add("hidden")
  }
}
